import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ClientTxnCategoryCreateModalSF from './ClientTxnCategoryCreateModalSF'
import ClientTxnCategoryUpdateModalSF from './ClientTxnCategoryUpdateModalSF'

const ClientTxnCategoryListUI = ({ context, account, errorList, categoryLabel,
  categoryList, categoryValueList, codeLabelList,
  // modes
  createMode, updateMode, selectedCategory,
  // event handlers
  onRefreshClick, onCreateClick, onUpdateClick, onCancelClick, onUpdate
}) =>
  <CardUI context={context} className='c_su_a_maps g_m_top_100' title={categoryLabel}>
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      categoryList &&
      <LRTableActionsUI location='top'
        left={
          <ActionLeftUI ontext={context} onRefreshClick={onRefreshClick} onCreateClick={onCreateClick} />
        }
        right={<span />}
      />
    }
    {
      categoryList && categoryList.length === 0 &&
      <div className='g_text_center'>No mappings yet</div>
    }

    {
      categoryList && categoryList.length !== 0 &&
      <ClientTxnCategoryList
        context={context}
        categoryList={categoryList}
        categoryValueList={categoryValueList}
        codeLabelList={codeLabelList}
        onRefreshClick={onRefreshClick}
        onUpdateClick={onUpdateClick}
        onUpdate={onUpdate}
      />
    }

    <ClientTxnCategoryCreateModalSF
      context={context}
      accountId={account ? account.accountId : ''}
      createMode={createMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      categoryList={categoryValueList}
    />

    <ClientTxnCategoryUpdateModalSF
      context={context}
      accountId={account ? account.accountId : ''}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedCategory={selectedCategory}
    />
  </CardUI>

const ClientTxnCategoryList = ({ context, categoryList, onRefreshClick, onUpdateClick, codeLabelList, categoryValueList }) =>
  <div className='su_ct_cats'>
    <div className='g_flex_h'
      style={{
        justifyContent: 'space-between',
        padding: '10px 16px',
        fontWeight: 600,
        borderBottom: '1px solid #ddd'
      }}
    >
      <span>
        Keyword
      </span>

      <span>
        Bank Analyzer Category
      </span>
    </div>
    <LRTableBodyUI>
      {
        categoryList.map((category, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} category={category} />}
            right={<RowRightUI category={category} onUpdateClick={onUpdateClick} codeLabelList={codeLabelList} />}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const RowLeftUI = ({ context, category }) =>
  <div className='g_flex_h'>
    <span>{category.keywords}</span>
    <i className='g_m_left_100'>
      {category.credit ? 'credit' : 'debit'}
    </i>
  </div>

const RowRightUI = ({ category, onUpdateClick, codeLabelList }) =>
  <div className='g_flex_h'>
    <span>
      {codeLabelList.filter(c => c.code === category.category).length > 0 &&
        codeLabelList.filter(c => c.code === category.category)[0].label}
      {codeLabelList.filter(c => c.code === category.category).length == 0 && category.category}
    </span>
    {
      codeLabelList.filter(c => c.code === category.category).length > 0 &&
      <span className='icon icon-pencil g_link_2 g_m_left_50'
        data-category={category.category} onClick={onUpdateClick} />
    }
  </div>

const ActionLeftUI = ({ context, onRefreshClick, onCreateClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
  </div>

export default ClientTxnCategoryListUI
